import { render, staticRenderFns } from "./replyed.vue?vue&type=template&id=16c8b8b4&scoped=true"
import script from "./replyed.vue?vue&type=script&lang=js"
export * from "./replyed.vue?vue&type=script&lang=js"
import style0 from "./replyed.vue?vue&type=style&index=0&id=16c8b8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8b8b4",
  null
  
)

export default component.exports